import { store } from "../../../../..";
import { clubhouseActions } from "../../../../../features/clubhouse/clubhouseSlice";
import {
    globalActions,
    selectAgeLevels,
    selectPositions,
} from "../../../../../features/global/globalSlice";

const loader = async ({ params }: any) => {
    const teamId = parseInt(params.teamId);

    const state = store.getState();
    const teams = state.clubhouse.teams;
    const settings = state.global.settings;
    const positions = selectPositions(state);
    const ageLevels = selectAgeLevels(state);
    const { user } = state.auth;
    const promises = [];

    !teams.length &&
        promises.push(
            store.dispatch(
                clubhouseActions.getTeams({ userId: user?.id as number }),
            ),
        );
    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));
    !positions.length &&
        promises.push(store.dispatch(globalActions.getPositions()));
    !ageLevels.length &&
        promises.push(store.dispatch(globalActions.getAgeLevels()));

    store.dispatch(clubhouseActions.setSelectedTeam(teamId));

    await Promise.all(promises);

    return {
        teamId,
    };
};

export default loader;
